import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { byteSize, Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IQuestionMentorFeedback } from 'app/shared/model/question-mentor-feedback.model';
import { getEntities } from './question-mentor-feedback.reducer';

export const QuestionMentorFeedback = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const questionMentorFeedbackList = useAppSelector(state => state.questionMentorFeedback.entities);
  const loading = useAppSelector(state => state.questionMentorFeedback.loading);
  const totalItems = useAppSelector(state => state.questionMentorFeedback.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  return (
    <div>
      <h2 id="question-mentor-feedback-heading" data-cy="QuestionMentorFeedbackHeading">
        <Translate contentKey="fivePlusApp.questionMentorFeedback.home.title">Question Mentor Feedbacks</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fivePlusApp.questionMentorFeedback.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/question-mentor-feedback/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fivePlusApp.questionMentorFeedback.home.createLabel">Create new Question Mentor Feedback</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {questionMentorFeedbackList && questionMentorFeedbackList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('meetingId')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.meetingId">Meeting Id</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('menteeId')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.menteeId">Mentee Id</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('mentorId')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.mentorId">Mentor Id</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('feedBack')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.feedBack">Feed Back</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.createdDate">Created Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('updatedDate')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.updatedDate">Updated Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('isShareFeedBack')}>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.isShareFeedBack">Is Share Feed Back</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fivePlusApp.questionMentorFeedback.question">Question</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {questionMentorFeedbackList.map((questionMentorFeedback, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/question-mentor-feedback/${questionMentorFeedback.id}`} color="link" size="sm">
                      {questionMentorFeedback.id}
                    </Button>
                  </td>
                  <td>{questionMentorFeedback.meetingId}</td>
                  <td>{questionMentorFeedback.menteeId}</td>
                  <td>{questionMentorFeedback.mentorId}</td>
                  <td>{questionMentorFeedback.feedBack}</td>
                  <td>
                    {questionMentorFeedback.createdDate ? (
                      <TextFormat type="date" value={questionMentorFeedback.createdDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {questionMentorFeedback.updatedDate ? (
                      <TextFormat type="date" value={questionMentorFeedback.updatedDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{questionMentorFeedback.isShareFeedBack ? 'true' : 'false'}</td>
                  <td>
                    {questionMentorFeedback.question ? (
                      <Link to={`/question/${questionMentorFeedback.question.id}`}>{questionMentorFeedback.question.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/question-mentor-feedback/${questionMentorFeedback.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/question-mentor-feedback/${questionMentorFeedback.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/question-mentor-feedback/${questionMentorFeedback.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.home.notFound">No Question Mentor Feedbacks found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={questionMentorFeedbackList && questionMentorFeedbackList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default QuestionMentorFeedback;
